import { ref, onMounted, onUnmounted } from 'vue';

export type ColorScheme = 'light' | 'dark';

export function useColorScheme() {
    const scheme = ref<ColorScheme>(
        typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light',
    );

    let mq: MediaQueryList | null = null;

    function onChange(e: MediaQueryListEvent) {
        scheme.value = e.matches ? 'dark' : 'light';
    }

    onMounted(() => {
        mq = window.matchMedia('(prefers-color-scheme: dark)');
        mq.addEventListener('change', onChange);
    });

    onUnmounted(() => {
        mq?.removeEventListener('change', onChange);
    });

    return { scheme };
}
